<template>
  <svg
    aria-hidden="true"
    class="-m-1"
    fill="currentColor"
    stroke="currentColor"
    stroke-width="8"
    width="1.25em"
    height="1.25em"
    viewBox="37.5 25 170 150"
  >
    <path d="m 96.4,91 v 20.1 c -1.1,0.4 -2.3,0.6 -3.5,0.6 -5.9,0 -10.7,-4.8 -10.7,-10.7 0,-5.9 4.8,-10.7 10.7,-10.7 1.2,0.1 2.4,0.3 3.5,0.7 z"/>
    <path d="m 68,93.9 c -3.9,0 -7.1,3.2 -7.1,7.1 0,3.9 3.2,7.1 7.1,7.1 3.9,0 7.1,-3.2 7.1,-7.1 0,-3.9 -3.2,-7.1 -7.1,-7.1 z"/>
    <path d="m 124.9,51.3 c 3.9,0 7.1,-3.2 7.1,-7.1 0,-3.9 -3.2,-7.1 -7.1,-7.1 -3.9,0 -7.1,3.2 -7.1,7.1 0,3.9 3.1,7.1 7.1,7.1 z"/>
    <path d="m 135.5,69 c 0,1.2 -0.2,2.4 -0.6,3.6 h -20.1 c -0.4,-1.1 -0.6,-2.3 -0.6,-3.6 0,-5.9 4.8,-10.7 10.7,-10.7 5.9,0.1 10.6,4.9 10.6,10.7 z"/>
    <path d="m 181.8,93.9 c -3.9,0 -7.1,3.2 -7.1,7.1 0,3.9 3.2,7.1 7.1,7.1 3.9,0 7.1,-3.2 7.1,-7.1 0,-3.9 -3.2,-7.1 -7.1,-7.1 z"/>
    <path d="m 167.5,101 c 0,5.9 -4.8,10.7 -10.7,10.7 -1.3,0 -2.5,-0.2 -3.6,-0.6 V 91 c 1.1,-0.4 2.3,-0.6 3.6,-0.6 6,0 10.7,4.8 10.7,10.6 z"/>
    <path d="m 124.9,150.8 c -3.9,0 -7.1,3.2 -7.1,7.1 0,3.9 3.2,7.1 7.1,7.1 3.9,0 7.1,-3.2 7.1,-7.1 0,-3.9 -3.2,-7.1 -7.1,-7.1 z"/>
    <path d="m 135.5,133 c 0,5.9 -4.8,10.7 -10.7,10.7 -5.9,0 -10.7,-4.8 -10.7,-10.7 0,-1.2 0.2,-2.4 0.6,-3.6 h 20.1 c 0.5,1.2 0.7,2.4 0.7,3.6 z"/>
    <circle cx="153.3" cy="72.599998" r="7.0999999"/>
    <circle cx="96.39999" cy="129.5" r="7.0999999"/>
    <circle cx="96.39999" cy="72.599998" r="7.0999999"/>
    <circle cx="153.3" cy="129.5" r="7.0999999"/>
  </svg>
</template>
